import logger from '../../Utils/logger';
import React from 'react';
import styles from './Style.module.css';
import AvatarCircleIcon from '../Icons/AvatarCircleIcon';
import MaleAvatarIcon from '../Icons/MaleAvatarIcon';
import FemaleAvatarIcon from '../Icons/FemaleAvatarIcon';
import { useAppointment } from '../../Context/Appointment/AppointmentContext';
import { getAddonPrice } from '../../Utils/addonPricing';

const ServiceDetails = ({ members, noServicePrice, noAddonsPrice, membership: membershipProp }) => {
  const { membership: membershipContext } = useAppointment();
  const membership = membershipProp ?? membershipContext ?? false;
  logger.log('ServiceDetails members:', members);

    const getSelectedAddonsPriceLabel = (addons = []) => {
        const totalAddonPrice = addons.reduce((total, addon) => total + getAddonPrice(addon), 0);
    
        return `From S$${totalAddonPrice.toFixed(2)}+`;
      };

  return (
    <div>
            {members.length > 0 ? (
            members.map((member, index) => (
            <div key={member.id} id={`guest-section-${member.id}`} className={`${styles.memberSection}`}>
              <div className={styles.memberCard}>
                <div className={styles.memberCardHeader}>
                  <div className={styles.memberCardHeaderLeft}>
                    <AvatarCircleIcon size={42} />
                    <div className={styles.memberCardHeaderLeftContent}>
                      <h2 className={styles.memberTitle}>
                        {member.name}
                      </h2>
                      <p className={styles.memberCardHeaderLeftServiceCount}>
                        {(member.services?.length ?? 0)}{" "}
                        {(member.services?.length ?? 0) === 1 ? "service" : "services"}
                      </p>
                    </div>
                  </div>
                </div>
                {(member.services ?? []).map((svc) => {
                  const memberPrice = svc?.price_rate?.member_after_6_or_weekends ?? 0;
                  const nonMemberPrice = svc?.price_rate?.nonMemberPrice;
                  
                  return (
                  <div key={`${member.id}-${svc.id}-${svc.count}`} className={styles.serviceCard}>
                    <div className={styles.serviceCardWithPrice}>
                      <div className={styles.serviceName}>
                          {svc.duration} mins {svc.name}
                      </div>
                      {!noServicePrice && <div className={styles.servicePrice}>
                        {membership ? (
                          <span>From S${memberPrice}+</span>
                        ) : (
                          <span>From S${nonMemberPrice}+</span>
                        )}
                      </div>}
                    </div>

                      {(svc.selectedAddons?.length ?? 0) > 0 && (
                        <div className={`${styles.serviceAddons} ${styles.serviceAddonsWithPrice}`}>
                          <div className={styles.serviceCardContent}>
                            <p className={styles.label}>Add-ons:</p>
                            <div className={styles.addonChipList}>
                              <span className={styles.text}>
                                {(svc.selectedAddons ?? [])
                                  .map((addon) => addon?.name)
                                  .filter(Boolean)
                                  .join(", ")}
                              </span>
                            </div>
                          </div>
                          {!noAddonsPrice && <div className={styles.serviceAddonsPrice}>
                            <span>{getSelectedAddonsPriceLabel(svc?.selectedAddons ?? [])}</span>
                          </div>}
                      </div>
                      )}
                    {svc?.therapistData?.requested && (
                    <div className={`${styles.therapistDetails} ${styles.serviceCardContent}`}>
                      <p className={styles.label}>Therapist:</p>
                      <div className={styles.selectedTherapist}>
                      {
                        svc?.therapistData?.gender === "male" ? <MaleAvatarIcon size={16} />
                        : svc?.therapistData?.gender === "female" ? <FemaleAvatarIcon size={16} />
                        : null}
                      <span className={styles.text}>{svc?.therapistData?.alias}</span>
                      </div>
                    </div>
                    )}
                  </div>
                  )
                })}
              </div>
              {members.length > 1 ? <div className={`${styles.hr} hr`} /> : ""}
            </div>
          ))
            ) : (
              <h5>Services not found</h5>
            )}
          </div>
  )
}

export default ServiceDetails
